import app from '~/app';
import cartPage from '~/js/components/cart-page';

app.add({
  'cart-page': cartPage,
});

app.mount();
